// extracted by mini-css-extract-plugin
module.exports = {"selectAllHeader":"SelectGroupList_selectAllHeader_1sDZI"};